export default __webpack_public_path__ + "static/media/mob_bold.2b4cd173.svg";